import { BodyText } from '@unmind/design-system';
import Label from 'Shared/Form/Label';
import { Close } from 'icons';
import { rem } from 'polished';
import styled, { css } from 'styled-components';
import { zIndex } from 'styles';
import { small } from 'utils/breakpoints';

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: ${rem(700)};
  overflow: scroll;
  padding: ${rem(16)};

  ${small(css`
    max-height: 100%;
    min-width: ${rem(400)};
  `)}
`;

export const AccessibilityLabel = styled(Label)`
  display: inline-flex;
`;

export const Title = styled(BodyText).attrs(({ theme }) => ({
  weight: theme.typography.fontWeights.bold,
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize16],
}))`
  padding: ${rem(16)};
`;

export const Subtitle = styled(BodyText).attrs(({ theme }) => ({
  weight: theme.typography.fontWeights.semiBold,
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize14],
}))`
  line-height: 100%;
  margin-top: ${rem(16)};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: ${rem(16)};

  > button {
    margin-left: ${rem(16)};
  }
`;

export const ContentContainer = styled.div`
  padding: 0 ${rem(16)};
  width: 100%;
`;

export const AddToCalendarField = styled.div<{
  multipleFields?: boolean;
  backgroundColour?: boolean;
}>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin: ${rem(12)} 0;

  align-items: ${({ multipleFields }) =>
    multipleFields ? 'flex-start' : 'center'};

  background-color: ${({ backgroundColour }) =>
    backgroundColour ? '#f3f3f5' : 'transparent'};
  border-radius: ${rem(8)};
  border: none;
  width: 100%;
`;

export const ModalWrapper = styled.div`
  padding: 0;
  border: none;
  z-index: 10;
  margin: ${rem(20)};
  max-height: 90vh;
  overflow: scroll;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

  ${small(css`
    position: absolute;
    width: ${rem(400)};
    overflow: hidden;
    max-height: 100vh;
  `)}
`;

export const CloseIcon = styled(Close).attrs(({ theme }) => ({
  primaryColor: theme.colors.text.primary,
  secondaryColor: theme.colors.text.primary,
}))`
  height: ${rem(10)};
  width: ${rem(10)};
`;

export const CloseIconButton = styled.div`
  padding: ${rem(16)};
  cursor: pointer;
  align-content: center;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background-color: ${({ theme }) => theme.colors.background.card};
  z-index: ${zIndex.overModal};

  ${small(css`
    position: relative;
  `)}
`;
